import { gql } from '@apollo/client';

const GET_PRODUCTS_VARIANTS = gql`
  query productVariants($params: QueryParams, $name: String) {
    productVariants(params: $params, name: $name) {
      info {
        count
      }
      results {
        id
        title
        img
        description
        price
        product {
          id
          name
          description
        }        
      }     
    }
  }
`;

const GET_GROUPS_COUPONS = gql`
  query groupsCoupon($params: QueryParams) {
    groupsCoupon(params: $params) {
      info {
        count
      }
      results {
        id
        group
      }     
    }
  }
`;

const UPDATE_COUPON = gql`
  mutation updateCoupon($id: ID!, $coupon: CouponUpdateInput!, $product: ProductUpdateInput) {
    updateCoupon(id: $id, coupon: $coupon, product: $product) {
      success
      message
      coupon { 
        id
      }  
    }
  }
`;

export { GET_PRODUCTS_VARIANTS, UPDATE_COUPON, GET_GROUPS_COUPONS }
